import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: 'E51AD3B8-0B73-4AE9-A4D9-0A8B8FE3EDF7',
  name: 'Draft',
  description:
    'The Engineering Judgement has been partially filled out and drafted, but is not yet ready to be issued',
  priority: 0,
})

const Closed = new StatusEnumItem({
  id: 'E1461C96-1AFA-4510-8B37-4D8906DF9B70',
  name: 'Closed',
  description:
    'The Engineering Judgement has been completely filled out and issued by an authorized user',
  priority: 1,
})

export type EJStatusItem = typeof Draft | typeof Closed

class EJStatusEnum extends StatusEnum<
  'EJStatus',
  EJStatusItem,
  EJStatusItem['name'],
  EJStatusItem['id'],
  EJStatusItem['priority']
> {
  readonly typename = 'EJStatus'
  readonly Draft = Draft
  readonly Closed = Closed
  get values() {
    return [this.Draft, this.Closed]
  }
}

export const EJStatus = new EJStatusEnum()
